module.exports = __webpack_public_path__ + "img/logo-colored.1e00e934.png";